export default "__VITE_ASSET__COQsw2si__"